<template>
  <div class="item-container">
    <div class="item">
      <router-link :to="'./'+id">
        <div class="item-image" >
          <img :src="svgUrl" alt="">
        </div>

        <div class="item-price">{{ price | money }}〜</div>
      </router-link>
    </div>
    <div class="item-favorite" @click="clickFavorite(id)" :class="{active: isFavorite}">
      <img v-if="!isFavorite" src="../../assets/img/star_off.svg"/>
      <img v-if="isFavorite" src="../../assets/img/star_on.svg"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ItemsItem',
    components: {},
    props: {
      'id': Number,
      'image': String,
      'name': String,
      'width': Number,
      'height': Number,
      'min_size': Number,
      'send_price': Number,
    },
    created () {
    },
    computed: {
      price () {
        const shortSize = Math.min(this.width, this.height);
        const longSize = Math.max(this.width, this.height);
        const longAspect = shortSize / longSize;

        return this.calcPrice(
          this.min_size,
          this.min_size * longAspect,
          this.image.length,
        1,
          this.send_price,
        );
      },
      isFavorite () {
        return this.$store.state.favorites.indexOf(this.id) !== -1;
      },
      svgUrl () {
        return `//admin.harigu.com/items/${this.id}.svg`;
      }
    },
    methods: {
      clickFavorite: function () {
        if (this.isFavorite) {
          this.$store.dispatch('removeFavorite', this.id);
        } else {
          this.$store.dispatch('addFavorite', this.id);
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .item-container {
    display: flex;
    justify-content: space-between;
    min-width: 100px;
    overflow: visible;
    .item {
      overflow: hidden;
      .thumbnail {
        width: 200px;
        figure {
          width: 100%;
        }
      }
      .detail {
        margin-left: 1rem;
        .title {
          background-color: rgb(128, 127, 128);
          color: #fff;
          text-align: center;
          border-radius: 0.5em;
        }
      }
      .item-price {
        text-align: center;
        background-color: rgb(89, 89, 89);
        color: rgb(240, 240, 240);
        border: 1px solid rgb(89, 89, 89);
      }
    }
    .item-favorite {
      width: 2rem;
      height: 2rem;
      color: black;
      position: absolute;
      bottom: -2px;
      right: -4px;
      &.active {
      }
    }
  }

  .buttons {
    button {
      color: #f0f0f0;
      border: 0;
      border-radius: .2rem;
      width: 10rem;
      &.button-change {
        background-color: rgb(128, 127, 128);
      }
      &.button-delete {
        margin-left: 10px;
        background-color: rgb(128, 87, 81);
      }
    }
  }
</style>

<style lang="scss" scoped>
  .item-container {
    position: relative;
    .item {
      width: 7.0rem;
      height: 7.5rem;
      border: 2px solid black;
      border-radius: 1rem;
      margin: 3px;
      overflow: hidden;
      .item-image {
        width: 100%;
        height: 80%;
        overflow: hidden;
        padding: 2px;
        filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
</style>

